export const SystemAttributeIds = {
    Department: "department",
    Gender: "gender",
    WorkLocation: "work-location",
    Division: "division",
    ReportingManager: "reporting-manager",
    City: "city",
    Region: "region",
    Country: "country",
    Pronouns: "pronouns",
    DateOfBirth: "date-of-birth",
    Interests: "interests",
    Competencies: "competencies",
    HireDate: "hire-date",
    TerminationDate: "termination-date",
    TerminationReason: "termination-reason"
} as const;

export type SystemAttributeId = (typeof SystemAttributeIds)[keyof typeof SystemAttributeIds];
